module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-autocomplete', {
    ref: "bauto",
    attrs: {
      "icon": "search",
      "icon-pack": "fa",
      "data": _vm.datasource,
      "placeholder": _vm.placeholder,
      "field": _vm.datafield,
      "keep-first": _vm.keepFirst,
      "expanded": ""
    },
    on: {
      "typing": _vm.ontyping,
      "select": function (option) { return _vm.selectWrapper(option); }
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onenter($event)
      }
    },
    model: {
      value: (_vm.inputVal),
      callback: function($$v) {
        _vm.inputVal = $$v
      },
      expression: "inputVal"
    }
  }, [(_vm.shownoresultstext) ? _c('template', {
    slot: "empty"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.noresultstext) + "\n\t\t\t\t\t")]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info is-hidden-tablet ",
    on: {
      "click": _vm.submit
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-hidden-tablet ",
    on: {
      "click": _vm.clear
    }
  }, [_c('strong', [_vm._v("X")])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info is-hidden-mobile ",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.searchtext))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-hidden-mobile ",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.cleartext))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5a41672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RxeobAutocomplete.vue
// module id = 107
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 16 17 18 22 23